import React from "react";
import uploadLogo from "../assets/welcome-graphic.png"; // Add an image placeholder for the mascot

const WelcomeStep = ({ onNext }) => {
  const styles = {
    container: {
      textAlign: "center",
      padding: "30px",
      maxWidth: "500px",
      margin: "40px auto",
      boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
      borderRadius: "12px",
      backgroundColor: "#fff",
    },
    image: {
      maxWidth: "200px",
      maxHeight: "200px",
      display: "block",
      margin: "0 auto 20px",
    },
    title: {
      fontSize: "26px",
      fontWeight: "bold",
      margin: "20px 0 10px",
      color: "#333",
    },
    text: {
      fontSize: "16px",
      margin: "0 0 30px",
      color: "#555",
      lineHeight: "1.5",
    },
    button: {
      padding: "12px 24px",
      backgroundColor: "#28a745",
      color: "#fff",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
      fontSize: "16px",
      transition: "background-color 0.3s ease",
    },
    buttonHover: {
      backgroundColor: "#218838",
    },
  };

  const handleMouseEnter = (e) => {
    e.target.style.backgroundColor = styles.buttonHover.backgroundColor;
  };

  const handleMouseLeave = (e) => {
    e.target.style.backgroundColor = styles.button.backgroundColor;
  };

  return (
    <div style={styles.container}>
      <img
        src={uploadLogo}
        alt="Welcome to Datakeet"
        style={styles.image}
      />
      <h2 style={styles.title}>Welcome to Datakeet!</h2>
      <p style={styles.text}>
        Ready to unlock the power of your data? Start by uploading your first
        file and let us help you make the most of your insights!
      </p>
      <button
        onClick={onNext}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={styles.button}
      >
        Upload CSV to Get Started
      </button>
    </div>
  );
};

export default WelcomeStep;
